/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Seller_Settings_TitleInputs */

const en_seller_settings_title = /** @type {(inputs: Seller_Settings_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Settings`)
};

const es_seller_settings_title = /** @type {(inputs: Seller_Settings_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configuración`)
};

const fr_seller_settings_title = /** @type {(inputs: Seller_Settings_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paramètres`)
};

const de_seller_settings_title = /** @type {(inputs: Seller_Settings_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einstellungen`)
};

const ja_seller_settings_title = /** @type {(inputs: Seller_Settings_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`設定`)
};

const zh_seller_settings_title = /** @type {(inputs: Seller_Settings_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`设置`)
};

const ar_seller_settings_title = /** @type {(inputs: Seller_Settings_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الإعدادات`)
};

const id_seller_settings_title = /** @type {(inputs: Seller_Settings_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pengaturan`)
};

const it_seller_settings_title = /** @type {(inputs: Seller_Settings_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impostazioni`)
};

const ru_seller_settings_title = /** @type {(inputs: Seller_Settings_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Настройки`)
};

const pt_seller_settings_title = /** @type {(inputs: Seller_Settings_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configurações`)
};

const ko_seller_settings_title = /** @type {(inputs: Seller_Settings_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`설정`)
};

/**
* | output |
* | --- |
* | "Settings" |
*
* @param {Seller_Settings_TitleInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const seller_settings_title = /** @type {((inputs?: Seller_Settings_TitleInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seller_Settings_TitleInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_seller_settings_title(inputs)
	if (locale === "es") return es_seller_settings_title(inputs)
	if (locale === "fr") return fr_seller_settings_title(inputs)
	if (locale === "de") return de_seller_settings_title(inputs)
	if (locale === "ja") return ja_seller_settings_title(inputs)
	if (locale === "zh") return zh_seller_settings_title(inputs)
	if (locale === "ar") return ar_seller_settings_title(inputs)
	if (locale === "id") return id_seller_settings_title(inputs)
	if (locale === "it") return it_seller_settings_title(inputs)
	if (locale === "ru") return ru_seller_settings_title(inputs)
	if (locale === "pt") return pt_seller_settings_title(inputs)
	return ko_seller_settings_title(inputs)
});